import { Button } from "@/design-system/components/ui";
import { signerWarningCopy, type LetterSignerCheckDto } from "../api/letterSigner";

// Owner Recapitalization Loan (letters.json popups → SignerMismatchWarning, OP4) —
// shown at the signing step of a recap Conditional Approval letter when the
// signing account's name differs from the signer staff named for the entity. A
// warning only: "Continue to sign" proceeds; "Return with comments" opens the
// chain's return dialog.

interface Props {
  check: LetterSignerCheckDto;
  onReturn: () => void;
  onContinue: () => void;
}

export function SignerMismatchDialog({ check, onReturn, onContinue }: Props) {
  const copy = signerWarningCopy(check);
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-onyx/50 p-space-4"
      data-testid="signer-mismatch"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={copy.title}
        className="max-w-lg w-full rounded-md bg-white-pure p-space-6 shadow-lg border-t-[2px] border-t-gold"
      >
        <h2 className="font-display font-bold text-h3 text-onyx m-0">{copy.title}</h2>
        <p className="text-body text-gray-mid mt-space-3 max-w-reading">{copy.body}</p>
        <div className="mt-space-5 flex justify-end gap-space-3 flex-wrap">
          <Button type="button" variant="secondary" onClick={onReturn} data-testid="signer-mismatch-return">
            {copy.returnLabel}
          </Button>
          <Button type="button" onClick={onContinue} data-testid="signer-mismatch-continue">
            {copy.continueLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
